import { ActivityProps } from '~/bootcamp/Activities/types/activities.types'
import { MatchingPairsQuestion } from '~/types/bootcamp'

export interface MatchingPairsProps extends ActivityProps {
  questions: MatchingPairsQuestion[]
}

export interface MatchingPairsActivityData {
  question: MatchingPairsQuestion
  questionIndex: number
}

export enum AnswerType {
  WRONG = 'wrong',
  CORRECT = 'correct',
  SELECT_CORRECT = 'select-correct',
  SELECT_ALL_CORRECT = 'select-all-correct',
  SELECT_ONLY_CORRECT = 'select-only-correct',
}
